import format from 'date-fns/format';
import _ from 'lodash';
import { defDateFormat } from '../../Helper/Constants';

export function buildFeedbackFormData({ selectedTitle, selectedOutlet, selectedBrand, status, dateRange }) {
	const formdata = new FormData();
	if (selectedTitle) formdata.append('feedback_title_id', selectedTitle);
	if (selectedOutlet) formdata.append('cust_code', selectedOutlet);
	if (selectedBrand) formdata.append('brand_code', selectedBrand);
	if (status) formdata.append('status', status);
	if (!_.isEmpty(dateRange)) {
		formdata.append('date_from', format(dateRange.startDate, defDateFormat));
		formdata.append('date_to', format(dateRange.endDate, defDateFormat));
	}
	return formdata;
}
